export default __webpack_public_path__ + "static/media/smarqand.5db489a3.webp";